import { memo } from "react"
import { Handle, Position, Node, NodeProps } from "@xyflow/react"
import MoleculeStructure from "../../../../components/Data/MoleculeStructure";
// import TruncatedText from "../../../../components/Page/TruncatedText";
import { ReadAcrossDataType } from "../../page/IndividualReadAcrossPage";

type CenterNode = Node<{
    label: string,
    smiles: string,
    angles: number[],
    radius: number,
    raData: ReadAcrossDataType,
    index: number,
    onOpenModal: (raData: ReadAcrossDataType, index: number) => void,
}, 'center'>;

export default memo(({ data }: NodeProps<CenterNode>) => {
    return (
        <div
            style={{ width: `${data.radius * 2}px` }}
            className="group aspect-square flex flex-col justify-center items-center gap-1 relative"
            onClick={() => data.onOpenModal(data.raData, data.index)}
        >
            <div><MoleculeStructure smiles={data.smiles} width={data.radius * 2 * 0.75} height={data.radius * 2 * 0.75}/></div>
            <p style={{ maxWidth: `${data.radius * 2}px` }} className="group-hover:underline transition-all text-[12px] text-default truncate font-medium">
                {data.label}
            </p>
            {data.angles.map((angle, i) => (
                <Handle 
                    key={i}
                    type='source'
                    id={`to-${i}`}
                    position={Position.Top}
                    style={{
                        position: 'absolute',
                        left: `${50 + 50 * Math.cos(angle)}%`,
                        top: `${50 + 50 * Math.sin(angle)}%`,
                        transform: 'translate(-50%, -50%)',
                        height: 0,
                        width: 0,
                        background: 'transparent',
                        border: 'none',
                    }}
                />
            ))}
        </div>
    )
})